import markNotificationAsRead from "@/actions/notifications/markNotificationAsRead";

const handleMarkAsRead = async ({ id, isRead }: NotificationFragment) => {
  if (!isRead) {
    await markNotificationAsRead(id);
  }
};

export default handleMarkAsRead;
